import { useDispatch } from "react-redux";

import { perimssionsActions } from "store/actions/permissions";

export const usePermissionsHook = () => {
  const dispatch = useDispatch();
  const getFormatModuleData = (modules) => {
    let data = {};
    if (!modules || !Array.isArray(modules) || !modules.length) return data;
    for (const module of modules) {
      const permissions = {};
      if (module && module.permissions && Array.isArray(module.permissions) && module.permissions.length) {
        for (const permission of module.permissions) {
          if (permission && permission.isSelected) {
            permissions[permission.permission] = true;
          }
        }
      }
      data[module.category] = { ...module, permissions };
    }
    return data;
  };
  const setModulePermissions = (roleDetailsData) => {
    if (roleDetailsData && roleDetailsData.categoryPermissions && Array.isArray(roleDetailsData.categoryPermissions)) {
      const formatedModulesData = getFormatModuleData(roleDetailsData.categoryPermissions);
      dispatch(
        perimssionsActions({
          modules: roleDetailsData.categoryPermissions,
          formatedModulesData: formatedModulesData,
          slug: roleDetailsData.slug || roleDetailsData.role,
          _id: roleDetailsData._id,
          role: roleDetailsData.role,
          isModuleLoading: false,
        })
      );
    }
  };

  return { setModulePermissions };
};
